export function isObjectWithKey<K extends string>(
  obj: unknown,
  key: K,
): obj is { [key in K]: unknown } {
  return !!obj && typeof obj === "object" && key in obj;
}
